module.exports = __webpack_public_path__ + "ac817053884cde48c9c0f8cc5574fb39.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/cube_blue.png
 ** module id = 1050
 ** module chunks = 0
 **/